import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// CUSTOM HOOKS
import useGetAllProtocolsLight from "../../../customHooks/GET_requests/useGetAllProtocolsLight";

function FormSelectProtocolType({
	inputValue,
	inputOnChange,
	inputLabelName,
}: {
	inputValue: string;
	inputLabelName: string;
	inputOnChange: (
		protocolId: string,
		protocolName: string,
		protocolDefaultInterface: string,
	) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { protocolsLight: protocols, isLoadingGetAllProtocolsLight } =
		useGetAllProtocolsLight({});

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeInputProtocol = (itemId: string) => {
		const index = protocols.findIndex((item: any) => item.id === itemId);
		if (index >= 0) {
			inputOnChange(
				protocols[index].id,
				protocols[index].name,
				protocols[index].default_interface || "{}",
			);
		}
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{inputLabelName}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							onChangeInputProtocol(e);
						}}
						value={inputValue}
						loading={isLoadingGetAllProtocolsLight}
					>
						{protocols.map(
							(item: {
								name: string;
								id: string;
								default_interface: string;
							}) => (
								<Option key={item.id} value={item.id}>
									{item.name}
								</Option>
							),
						)}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}

export default FormSelectProtocolType;
